import React from "react";

import type {
  Destination,
  DestinationValidation,
} from "../../../../application/domain/proc-management";
import { getMaxLength } from "../../../../application/domain/proc-management/util/input-max-length";
import { FormFieldLabel } from "../../../atoms/proc-management/form";
import { ListInput } from "./list-input";
import { SimpleTextInput } from "./simple-text-input";
import type { InputProps, PathProps } from "./types";

type DestinationInputProps = Destination &
  InputProps &
  PathProps & { validationErrors?: DestinationValidation };

export const DestinationInput: React.FC<DestinationInputProps> = (props) => {
  const {
    onChange,
    basePath,
    postalCode,
    address1,
    address2,
    address3,
    name,
    tel,
    disabled = false,
    shouldDisplayError,
    validationErrors,
  } = props;
  const usedIf = props.usedIf ?? [];
  const usedIfvalidationErrors = validationErrors?.usedIf ?? [];
  return (
    <div>
      <div className="mb-2">
        <FormFieldLabel label="郵送先郵便番号" bold={false} required />
        <SimpleTextInput
          onChange={onChange}
          basePath={[...basePath, "postalCode"]}
          value={postalCode}
          disabled={disabled}
          shouldDisplayError={shouldDisplayError}
          errorMsg={validationErrors?.postalCode}
        />
      </div>

      <div className="mb-2">
        <FormFieldLabel
          label="住所 - 丁目番地号より前まで"
          bold={false}
          required
        />
        <SimpleTextInput
          onChange={onChange}
          basePath={[...basePath, "address1"]}
          value={address1}
          disabled={disabled}
          shouldDisplayError={shouldDisplayError}
          errorMsg={validationErrors?.address1}
          maxLength={getMaxLength("byMailDestAddress")}
        />
      </div>

      <div className="mb-2">
        <FormFieldLabel label="住所 - 丁目番地号" bold={false} required />
        <SimpleTextInput
          onChange={onChange}
          basePath={[...basePath, "address2"]}
          value={address2}
          disabled={disabled}
          shouldDisplayError={shouldDisplayError}
          errorMsg={validationErrors?.address2}
          maxLength={getMaxLength("byMailDestAddress")}
        />
      </div>

      <div className="mb-2">
        <FormFieldLabel label="住所 - ビル名部屋番号会社名等" bold={false} />
        <SimpleTextInput
          onChange={onChange}
          basePath={[...basePath, "address3"]}
          value={address3}
          disabled={disabled}
          shouldDisplayError={shouldDisplayError}
          errorMsg={validationErrors?.address3}
          maxLength={getMaxLength("byMailDestAddress")}
        />
      </div>

      <div className="mb-2">
        <FormFieldLabel label="住所 - 受取人名など" bold={false} required />
        <SimpleTextInput
          onChange={onChange}
          basePath={[...basePath, "name"]}
          value={name}
          disabled={disabled}
          shouldDisplayError={shouldDisplayError}
          errorMsg={validationErrors?.name}
          maxLength={getMaxLength("byMailDestName")}
        />
      </div>

      <div className="mb-2">
        <FormFieldLabel label="電話番号" bold={false} />
        <SimpleTextInput
          onChange={onChange}
          basePath={[...basePath, "tel"]}
          value={tel}
          disabled={disabled}
          shouldDisplayError={shouldDisplayError}
          errorMsg={validationErrors?.tel}
        />
      </div>

      <ListInput
        label="利用条件"
        boldLabel={false}
        mb={2}
        component={SimpleTextInput}
        componentProps={usedIf.map((value, i) => ({
          value,
          onChange,
          shouldDisplayError,
          errorMsg: usedIfvalidationErrors[i],
        }))}
        basePath={[...basePath, "usedIf"]}
        onPush={() => {
          onChange([...basePath, "usedIf"], [...usedIf, ""]);
        }}
        onRemove={(i) => {
          onChange(
            [...basePath, "usedIf"],
            [...usedIf.slice(0, i), ...usedIf.slice(i + 1)],
          );
        }}
        disabled={disabled}
        notices={[
          "特定のケースでのみ郵送を受け付ける場所がある場合、そのための条件を指定することができます。",
          "例: 納税義務者又はその代理人以外で訴えの提起を行う方が手続きを行う場合",
        ]}
      />
    </div>
  );
};
